<template>
<div>
    <b-modal size="lg" title="Enviar Certificado Digital" ref="modal">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label>Arquivo Certificado Digital (.pfx):</label>
                    <input ref="fileInput" type="file" class="form-control-file" @change="onFileSelected" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <password-input v-model="form.password.value" :name="'password'" :form="form" :alias="form.password.alias"></password-input>
            </div>
        </div>

        <error-handler :error="error" />

        <div slot="modal-footer">
            <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
                <i class="fas fa-times"></i> Cancelar
            </button>
            <button role="button" class="btn btn-success ml-2" @click="store">
                <i class="fas fa-check"></i> Salvar
            </button>
        </div>
    </b-modal>
</div>
</template>

<script>
import Form from "./../../mixins/Form.js";
//import CertificateApi from './../api/CertificateApi.js'

export default {
    data() {
        return {
            form: new Form({
                password: {
                    validate: {
                        required: ""
                    },
                    alias: "Senha"
                },

                certificate: {},

                fileName: {}
            }),

            error: null
        };
    },

    methods: {
        open() {
            this.$refs.modal.show();

            this.error = null;

            this.form.password.value = null;
            this.form.certificate.value = null;
            this.form.fileName.value = null;

            //this.$refs.fileInput.value = null
        },

        onFileSelected(event) {
            console.log(event);
            this.form.certificate.value = event.target.files[0];
            this.form.fileName.value = event.target.files[0].name;
        },

        store() {
            if (this.form.isValid()) {
                this.$store.commit("showLoading");

                let form = new FormData();

                form.append("certificate", this.form.certificate.value, "certificate");
                form.append("password", this.form.password.value);
                form.append("fileName", this.form.fileName.value);

                axios
                    .post("api/certificate/store", form)
                    .then(response => {

                        this.$store.commit("hideLoading");
                        this.$emit("stored", this.form.getValues());
                        this.$refs.modal.hide();
                        this.$store.commit("showAlert", {
                            message: "Certificado Adicionado com sucesso!",
                            type: "Success"
                        });
                    })
                    .catch(error => {
                        console.log(error)
                        this.error = error;
                        this.$store.commit("hideLoading");
                    });
            }
        }
    }
};
</script>
